import React from 'react';

export interface TagFilterRowProps {
  suggestedTags: string[];
  includeTags: string[];
  includeTagInput: string;
  setIncludeTagInput: (v: string) => void;
  addIncludeTag: (tag: string) => void;
  removeIncludeTag: (tag: string) => void;
  includeSuggestions: string[];
  excludeTags: string[];
  excludeTagInput: string;
  setExcludeTagInput: (v: string) => void;
  addExcludeTag: (tag: string) => void;
  removeExcludeTag: (tag: string) => void;
  excludeSuggestions: string[];
}

const TagFilterRow: React.FC<TagFilterRowProps> = ({
  suggestedTags,
  includeTags,
  includeTagInput,
  setIncludeTagInput,
  addIncludeTag,
  removeIncludeTag,
  includeSuggestions,
  excludeTags,
  excludeTagInput,
  setExcludeTagInput,
  addExcludeTag,
  removeExcludeTag,
  excludeSuggestions,
}) => (
  <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '1.5rem' }}>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', minWidth: 0, maxWidth: '320px' }}>
      <span style={{ fontSize: '0.85rem', color: '#555' }}>Include tags</span>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '0.35rem', padding: '0.4rem', border: '1px solid #dee2e6', borderRadius: '4px', background: '#fff' }}>
        {includeTags.map((tag) => (
          <span key={tag} style={{ display: 'inline-flex', alignItems: 'center', gap: '0.2rem', padding: '0.2rem 0.4rem', fontSize: '0.85rem', background: '#e7f1ff', border: '1px solid #b6d4fe', borderRadius: '4px' }}>
            {tag}
            <button type="button" onClick={() => removeIncludeTag(tag)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, lineHeight: 1, color: '#666' }} aria-label={`Remove ${tag}`}>×</button>
          </span>
        ))}
        <input
          type="text"
          value={includeTagInput}
          onChange={(e) => setIncludeTagInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              e.stopPropagation();
              addIncludeTag(includeTagInput);
            }
          }}
          placeholder="Add tags here..."
          style={{ border: 'none', outline: 'none', padding: '0.2rem', fontSize: '0.9rem', minWidth: '120px', flex: '1 1 120px' }}
        />
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem', marginTop: '0.2rem', alignItems: 'center' }}>
        <span style={{ fontSize: '0.8rem', color: '#666', marginRight: '0.3rem' }}>Suggestions:</span>
        {suggestedTags.length === 0 ? (
          <span style={{ fontSize: '0.8rem', color: '#999' }}>No tags in this result set</span>
        ) : includeSuggestions.length === 0 ? (
          <span style={{ fontSize: '0.8rem', color: '#999' }}>All selected</span>
        ) : (
          includeSuggestions.slice(0, 20).map((tag) => (
            <button key={tag} type="button" onClick={() => addIncludeTag(tag)} style={{ padding: '0.2rem 0.4rem', fontSize: '0.8rem', border: '1px solid #ccc', borderRadius: '4px', background: '#fff', cursor: 'pointer' }}>{tag}</button>
          ))
        )}
      </div>
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', minWidth: 0, maxWidth: '320px' }}>
      <span style={{ fontSize: '0.85rem', color: '#555' }}>Exclude tags</span>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '0.35rem', padding: '0.4rem', border: '1px solid #dee2e6', borderRadius: '4px', background: '#fff' }}>
        {excludeTags.map((tag) => (
          <span key={tag} style={{ display: 'inline-flex', alignItems: 'center', gap: '0.2rem', padding: '0.2rem 0.4rem', fontSize: '0.85rem', background: '#f8d7da', border: '1px solid #f1aeb5', borderRadius: '4px' }}>
            {tag}
            <button type="button" onClick={() => removeExcludeTag(tag)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, lineHeight: 1, color: '#666' }} aria-label={`Remove ${tag}`}>×</button>
          </span>
        ))}
        <input
          type="text"
          value={excludeTagInput}
          onChange={(e) => setExcludeTagInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              e.stopPropagation();
              addExcludeTag(excludeTagInput);
            }
          }}
          placeholder="Add tags here..."
          style={{ border: 'none', outline: 'none', padding: '0.2rem', fontSize: '0.9rem', minWidth: '120px', flex: '1 1 120px' }}
        />
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem', marginTop: '0.2rem', alignItems: 'center' }}>
        <span style={{ fontSize: '0.8rem', color: '#666', marginRight: '0.3rem' }}>Suggestions:</span>
        {suggestedTags.length === 0 ? (
          <span style={{ fontSize: '0.8rem', color: '#999' }}>No tags in this result set</span>
        ) : excludeSuggestions.length === 0 ? (
          <span style={{ fontSize: '0.8rem', color: '#999' }}>All selected</span>
        ) : (
          excludeSuggestions.slice(0, 20).map((tag) => (
            <button key={tag} type="button" onClick={() => addExcludeTag(tag)} style={{ padding: '0.2rem 0.4rem', fontSize: '0.8rem', border: '1px solid #ccc', borderRadius: '4px', background: '#fff', cursor: 'pointer' }}>{tag}</button>
          ))
        )}
      </div>
    </div>
  </div>
);

export default TagFilterRow;
